import React from 'react';
import Navbar from '../organisms/Navbar';

function Header() {
  return (
    <header>
      <Navbar />
    </header>
  );
}

export default Header;
